import React from 'react';
import { NumericTextBox } from "@progress/kendo-react-inputs";

function Int32Editor(props) {

    if (typeof(props.id) != 'string') {
        throw new TypeError("Required ID prop has not been set")
    }

    const onEditorChange = (e) => {

        if (props.onChange) {
            props.onChange({ originalEvent: e, value: e.target.value, props: props });
        }
    }

    return (
        (props.naked ?
            <NumericTextBox
                format="n0"
                tabIndex={props.tabIndex}
                value={props.value}
                spinners={props.spinners}
                onChange={onEditorChange} />
            :
        <td className={props.className || "control"} colSpan={props.colSpan}>
            <NumericTextBox
                format="n0"
                tabIndex={props.tabIndex}
                value={props.value}
                spinners={props.spinners}
                onChange={onEditorChange} />
        </td>
        )
    )
}

export default Int32Editor;